"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _partial = _interopRequireDefault(require("react-utils/partial"));

var _Functions = require("../core/Functions");

var _UILayer = _interopRequireDefault(require("../layer/UILayer"));

var _AlertListTransition = _interopRequireDefault(require("./AlertListTransition"));

var _FloatingAlertStore = _interopRequireDefault(require("./FloatingAlertStore"));

var _UIFloatingAlert = _interopRequireDefault(require("./UIFloatingAlert"));

var DEFAULT_TOP_OFFSET = 20;
var NAV_BAR_ELEMENT_ID_V4 = 'hs-nav-v4';
var FLOATING_ALERT_SUBSCRIPTION_KEY = 'UIFloatingAlertList';
var subscriptionKeyId = 0;

var sortAlerts = function sortAlerts(alertsFromProps, alertsFromStore) {
  return [].concat((0, _toConsumableArray2.default)(alertsFromProps), (0, _toConsumableArray2.default)(alertsFromStore)).sort(function (a, b) {
    return a.timestamp - b.timestamp;
  });
};

var subscribeToAlertStore = function subscribeToAlertStore(instance, alertStore) {
  alertStore.subscribe(instance.storeSubscriptionKey, function (alertsFromStore) {
    instance.setState({
      alertsFromStore: alertsFromStore
    });
  });
};

var unsubscribeFromAlertStore = function unsubscribeFromAlertStore(instance, alertStore) {
  alertStore.unsubscribe(instance.storeSubscriptionKey);
};

var getStyle = function getStyle(style, topOffset) {
  return (0, _extends2.default)({}, style, {
    top: topOffset
  });
};

var UIFloatingAlertList = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(UIFloatingAlertList, _PureComponent);

  function UIFloatingAlertList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIFloatingAlertList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIFloatingAlertList).call(this, props));

    _this.updateContainerOffset = function () {
      var scrollTop = document.documentElement.scrollTop;
      var navElement = document.getElementById(NAV_BAR_ELEMENT_ID_V4);
      var navHeight = 0;

      if (navElement) {
        navHeight = navElement.clientHeight;
      }

      var maxTopOffset = DEFAULT_TOP_OFFSET + navHeight;

      if (scrollTop > navHeight) {
        _this.setState({
          topOffset: DEFAULT_TOP_OFFSET
        });
      } else {
        _this.setState({
          topOffset: maxTopOffset - scrollTop
        });
      }
    };

    _this.handleAlertClose = function (alert, evt) {
      var onAlertClose = _this.props.onAlertClose;
      (0, _Functions.callIfPossible)(alert.onClose, evt, alert);
      (0, _Functions.callIfPossible)(onAlertClose, evt, alert);
    };

    _this.state = {
      alertsFromStore: [],
      topOffset: null
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    _this.storeSubscriptionKey = FLOATING_ALERT_SUBSCRIPTION_KEY + "-" + subscriptionKeyId++;
    return _this;
  }

  (0, _createClass2.default)(UIFloatingAlertList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          alertStore = _this$props.alertStore,
          use = _this$props.use;

      if (use !== 'contextual') {
        addEventListener('scroll', this.updateContainerOffset);
        this.updateContainerOffset();
      }

      subscribeToAlertStore(this, alertStore);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var alertStore = this.props.alertStore;

      if (prevProps.alertStore !== alertStore) {
        unsubscribeFromAlertStore(this, prevProps.alertStore);
        subscribeToAlertStore(this, alertStore);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          alertStore = _this$props2.alertStore,
          use = _this$props2.use;

      if (use !== 'contextual') {
        removeEventListener('scroll', this.updateContainerOffset);
      }

      unsubscribeFromAlertStore(this, alertStore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          alerts = _this$props3.alerts,
          __alertStore = _this$props3.alertStore,
          className = _this$props3.className,
          __onAlertClose = _this$props3.onAlertClose,
          style = _this$props3.style,
          use = _this$props3.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props3, ["alerts", "alertStore", "className", "onAlertClose", "style", "use"]);
      var _this$state = this.state,
          alertsFromStore = _this$state.alertsFromStore,
          topOffset = _this$state.topOffset;
      var renderedAlerts = sortAlerts(alerts, alertsFromStore).map(function (alert) {
        var id = alert.id,
            message = alert.message,
            __onClose = alert.onClose,
            __timestamp = alert.timestamp,
            titleText = alert.titleText,
            type = alert.type,
            alertRest = (0, _objectWithoutProperties2.default)(alert, ["id", "message", "onClose", "timestamp", "titleText", "type"]);
        return _react.default.createElement(_UIFloatingAlert.default, (0, _extends2.default)({
          key: id,
          onClose: (0, _partial.default)(_this2.handleAlertClose, alert),
          titleText: titleText,
          type: type
        }, alertRest), message);
      });
      var computedClassName = (0, _classnames.default)('private-floating-alert-list', className, {
        'private-floating-alert-list--contextual': use === 'contextual'
      });

      var computedStyle = this._getStyle(style, topOffset);

      var renderedAlertList = _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        className: computedClassName,
        style: computedStyle
      }), _react.default.createElement("div", {
        className: "private-floating-alert-list__child-wrapper"
      }, _react.default.createElement(_AlertListTransition.default, null, renderedAlerts)));

      if (use === 'contextual') {
        return renderedAlertList;
      }

      return _react.default.createElement(_UILayer.default, {
        "data-layer-for": "UIFloatingAlertList"
      }, renderedAlertList);
    }
  }]);
  return UIFloatingAlertList;
}(_react.PureComponent);

UIFloatingAlertList.propTypes = {
  alerts: _propTypes.default.array.isRequired,
  alertStore: _propTypes.default.object.isRequired,
  onAlertClose: _propTypes.default.func,
  use: _propTypes.default.oneOf(['fullscreen', 'contextual'])
};
UIFloatingAlertList.defaultProps = {
  alerts: [],
  alertStore: _FloatingAlertStore.default,
  use: 'fullscreen'
};
UIFloatingAlertList.displayName = 'UIFloatingAlertList';
var _default = UIFloatingAlertList;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/alert/UIFloatingAlertList.js
// module id = 647
// module chunks = 209 210 211 212